module.exports = __webpack_public_path__ + "img/nature-vs-humans-cover.cdde2ff9.jpg";